import { createActor } from 'xstate';
import { draftMachine } from 'xstate/machines/DraftMachine';
import { EventType } from 'xstate/machines/DraftMachine';
import { getStore, storeKeys } from 'core/storage/store';
import type { JSONContent } from '@tiptap/core';

/**
 * TODO: https://mindfeed.atlassian.net/browse/SP-334
 * Update persistence implementation to store the full machine state instead of just the context.
 *
 * Current implementation only persists the machine context in the local storage, that is not a good
 * practice, we should persist the state machine
 */

// Initial context: Load from storage or use defaults
const initialContext = getStore().getItem(storeKeys.xStateDraftMachine) || {
  newDraft: undefined,
  drafts: {},
};

// Create actor with initial context
export const DraftActor = createActor(draftMachine, {
  input: initialContext,
});

// Subscribe to state changes for persistence
DraftActor.subscribe((snapshot) => {
  getStore().setItem(storeKeys.xStateDraftMachine, snapshot.context);
});

DraftActor.start();

// Service API
export const createDraft = (id: string | undefined, document: JSONContent) => {
  DraftActor.send({
    type: EventType.CreateDraft,
    id,
    document,
  });
};

export const editDraft = (id: string | undefined, document: JSONContent) => {
  DraftActor.send({
    type: EventType.EditDraft,
    id,
    document,
  });
};

export const saveDraft = (id: string | undefined) => {
  DraftActor.send({
    type: EventType.SaveDraft,
    id,
  });
};

export const discardDraft = (id: string | undefined) => {
  DraftActor.send({
    type: EventType.DiscardDraft,
    id,
  });
};

// Utility functions
export const getDraft = (id: string | undefined) => {
  const snapshot = DraftActor.getSnapshot();
  return id ? snapshot.context.drafts[id] : snapshot.context.newDraft;
};
